import { IComponentOptions, IController } from "angular";
import { OkrStatus } from "@webapp/okrs/goals/models/goal-status.models";

class OkrStatusLabelCtrl implements IController {
  status: OkrStatus;
}

export const OkrStatusLabelComponent: IComponentOptions = {
  template: `
    <div class="okr-status-wrapper" ng-class="{'active': $ctrl.status === 'active', 'achieved': $ctrl.status === 'achieved', 'abandoned': $ctrl.status === 'abandoned'}" data-test-id="okr-status-label">
      {{ $ctrl.status | localize }}
    </div>`,
  controller: OkrStatusLabelCtrl,
  bindings: {
    status: "<",
  },
};
